<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title
        v-if="!helpers.dataIsLoading"
        class="px-0"
        :class="
          $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
        "
        >Letzte Auslagen<v-spacer></v-spacer>
        <v-btn text outlined small>Alle anzeigen</v-btn>
      </v-card-title>
      <div>
        <v-skeleton-loader
          v-if="helpers.dataIsLoading"
          elevation="2"
          type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
        ></v-skeleton-loader>
        <v-data-iterator
          v-else
          :items="expenses"
          no-data-text="Keine Auslagen vorhanden"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-row class="match-height">
              <v-col
                v-for="expense in props.items"
                :key="expense.meta.id"
                cols="12"
                sm="4"
                md="4"
              >
                <v-card
                  :to="{
                    name: 'finances-expenses-details',
                    params: { itemId: expense.meta.id },
                  }"
                >
                  <v-card-title class="subtitle-1 font-weight-medium mt-1 mb-1">
                    <span v-if="expense.title">{{ expense.title }}</span>
                    <span v-else class="grey--text">Bericht ohne Titel</span>
                    <v-spacer></v-spacer>
                    <!-- <expense-status-chip :status="expense.status" small>
                    </expense-status-chip> -->
                  </v-card-title>
                  <v-card-subtitle class="fonrt-weight-regular">
                    <p style="line-height: 1.6" class="mb-0">
                      <v-icon small left>mdi-circle</v-icon
                      >{{ expense.type.title }}
                      <br />
                      <v-icon small left>mdi-clock-start</v-icon
                      ><span>
                        Erstellt am
                        {{ timestampConverter(expense.meta.createdAt) }}
                      </span>
                    </p>
                  </v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </div>
    </v-card>
  </div>
</template>

<script>
// import { FINANCES } from "@/store/modules.js";
// import { GET_EXPENSES } from "@/store/action-types.js";
// import ExpenseStatusChip from "@/components/finances/ExpenseStatusChip.vue";
export default {
  name: "self-service-open-duty-expenses",
  props: {},
  components: {
    // ExpenseStatusChip,
  },
  data() {
    return {
      helpers: {
        dataIsLoading: false,
      },
    };
  },
  computed: {
    expenses() {
      return this.$store.state.finance.expenses;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      // this.$store.dispatch(`${FINANCES}${GET_EXPENSES}`, {
      //   organizationId: this.$route.params.organizationId,
      //   query: {
      //     onlyOwn: true,
      //   },
      //   paginationLimit: 3,
      // });
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>
